import { useQuery } from "@tanstack/react-query";
import { getCountries } from "../api";

export const useGetCountries = () => {
  return useQuery({
    queryKey: ["countries"],
    queryFn: () => getCountries(),
    staleTime: 1000 * 60 * 5, 
    cacheTime: 1000 * 60 * 10, 
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};